import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/add.svg';

export const IconAdd = createIconComponent(Icon);
